export function formatarTelefone(telefone: string) {
  if (!telefone) return;

  // Remove tudo que não for número
  const cleaned = telefone.replace(/\D/g, "");

  if (cleaned.length === 10) {
    // Telefone fixo: (XX) XXXX-XXXX
    return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  }

  if (cleaned.length === 11) {
    // Celular: (XX) 9XXXX-XXXX
    return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  }

  // Número inválido ou incompleto
  return telefone;
}

export function limparTelefone(telefone: string): string {
  return telefone.replace(/\D/g, ""); // mantém apenas números
}
